import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import {Modal} from 'antd'
import React, {useEffect} from 'react'
import {useToggle} from 'react-use'
import {DelayRender} from "../../../views/Discovery/DelayRender";
import useTranslate from "../../../modules/local/useTranslate";
import {renderIf} from "../../../views/Shared";

export const DrawerPopupDialog = ({
                                      component = <EllipsisOutlined/>,
                                      children,
                                      title,
                                      open,
                                      setVisible,
                                      width,
                                      footer = true,
                                      ...props
                                  }) => {
    const t = useTranslate();
    const [isToggle, toggle] = useToggle(open)

    useEffect(() => {
        toggle(!!open)
    }, [open])

    return (
        <Modal
            {...props}
            width={width}
            className="custom-modal"
            footer={null}
            destroyOnHidden={true}
            open={isToggle}
            onCancel={() => {
                toggle(false)
                setVisible(false)
            }}
            title={title}>
            <DelayRender lazy={true}>
                {children(isToggle, toggle)}
            </DelayRender>
            {renderIf(
                footer === true,
                <div
                    onClick={toggle}
                    className="mt-6 p-3 text-right text-sm text-color-300 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </div>
            )}

        </Modal>
    )

}

export default DrawerPopupDialog
